/* Kiomia - logica della pillola d'acquisto.

   Due condizioni, tutte e due devono essere vere perche' si veda:
   1. siamo arrivati alla sezione dei tre passi (prima la pagina resta pulita);
   2. il pulsante d'acquisto vero non e' sullo schermo.

   Il clic resta gestito da km-pdp.js tramite data-km-sticky-add. */
(function(){
  function avvia(){
    var pillole = document.querySelectorAll('[data-km-sticky]:not([data-km-pillola])');
    Array.prototype.forEach.call(pillole, function(b){
      var ancora = document.querySelector('[data-km-add]');
      if (!ancora) return;
      b.setAttribute('data-km-pillola', '1');
      b.classList.add('is-nascosta');

      var ancoraVisibile = false;

      function aggiorna(){
        var oltre = true;
        if (window.kmSoglia && window.kmSoglia.esiste()) oltre = window.kmSoglia.superata();
        b.classList.toggle('is-nascosta', ancoraVisibile || !oltre);
      }

      if ('IntersectionObserver' in window){
        new IntersectionObserver(function(voci){
          ancoraVisibile = voci[0].isIntersecting;
          aggiorna();
        }, { threshold: 0, rootMargin: '0px 0px -90px 0px' }).observe(ancora);
      }
      window.addEventListener('scroll', aggiorna, { passive: true });
      window.addEventListener('resize', aggiorna);
      aggiorna();

      /* Il prezzo segue quello della scheda (varianti e offerte). */
      var sorgente = document.querySelector('[data-km-price]');
      var arrivo = b.querySelector('[data-km-sticky-price]');
      if (sorgente && arrivo){
        var copia = function(){
          var t = (sorgente.textContent || '').replace(/\s+/g, ' ').trim();
          if (t) arrivo.textContent = t;
        };
        copia();
        if ('MutationObserver' in window){
          new MutationObserver(copia).observe(sorgente, { childList: true, characterData: true, subtree: true });
        }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
  document.addEventListener('shopify:section:load', avvia);
})();
